




import Vue, { PropType } from 'vue';
import { camelCase } from 'lodash';
import InfoIcon from '@/components/molecules/infoIcon/InfoIcon.vue';
import { ApplicationStatusDetail } from '@/api/interfaces/content/common/applicationStatusDetail';

export default Vue.extend({
    name: 'StatusInfoAccordion',
    components: {
        InfoIcon,
    },
    props: {
        status: {
            type: String,
            required: true,
        },
        applicationStatusItems: {
            type: Object as PropType<Record<
                string,
                ApplicationStatusDetail
            > | null>,
            default: null,
        },
    },
    computed: {
        accordionHtml(): string {
            if (!this.applicationStatusItems) {
                return '';
            }
            const statusKey = camelCase(this.status);
            const sortedStatuses = Object.entries(this.applicationStatusItems)
                .filter(([key]) => key !== 'deleted')
                .sort(([, a], [, b]) => a.order - b.order);
            const totalItems = sortedStatuses.length;

            const items = sortedStatuses
                .map(([key, detail], index) => {
                    const isActive = key === statusKey;
                    const isLast = index === totalItems - 1;
                    const openAttr = isActive ? ' open data-default-open' : '';
                    const classes = [
                        'status-timeline-item',
                        isActive ? 'status-timeline-item--active' : '',
                        isLast ? 'status-timeline-item--last' : '',
                    ]
                        .filter(Boolean)
                        .join(' ');

                    return `<div class="${classes}"><div class="status-timeline-marker"></div><details name="status-accordion-${statusKey}"${openAttr}><summary class="status-timeline-summary">${detail.label}</summary><p class="status-timeline-description">${detail.description}</p></details></div>`;
                })
                .join('');

            return `<div class="status-timeline">${items}</div>`;
        },
    },
});
